import {nanoid} from "nanoid"

import App from "@fae/source/models/App.js"
import World from "@fae/source/models/World.js"
import Stage from "@fae/source/models/Stage.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"
import * as PlotConditions from "@fae/source/data/plot/conditions.js"
import * as PlotScripts from "@fae/source/data/plot/scripts.js"


import Navigation from "@fae/source/engine/navigating/Navigation.js"
import Step from "@fae/source/models/Step.js"
import Objdict from "objdict"

import * as EmberFlow from "../../scripts/EmberFlow.js"
import ContinuePrompt from "../../views/hud/ContinuePrompt.jsx"
import HandleSlowDeath from "../../scripts/HandleSlowDeath.js"

export default {
    "key": "test",
    "decorations": {
        "hasSnow": true,
    },
    "stage": {
        "image": require("./tiles.png"),
        "units": require("./units.json"),
        "world": World.parse({
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
        }),
        "hud": ContinuePrompt,
        "scripts": [
            {
                "trigger": "turn:0:start",
                "events": [
                    // PlotSteps.ReportStartingAnalytics(),
                    PlotSteps.SpawnPlayerParty({"defaultPartyUnitKeys": ["bard", "hero", "witch"]}),
                    PlotSteps.PlayAudio("Ember:Music:Combat"),
                    EmberFlow.SpawnInitialEnemyUnits({
                        "monsterKeys": ["woodsman-green", "wisp-green", "wisp-green"],
                        "bossmonsterKey": "leshy-green"
                    }),
                ]
            },
            {
                "trigger": "turn:every:end",
                "events": [
                    HandleSlowDeath(),
                ]
            },
            // {
            //     "trigger": "turn:every-odd:end",
            //     "events": [
            //         EmberFlow.SpawnIncomingEnemyUnits(),
            //     ]
            // },
            // {
            //     "trigger": "turn:every-odd:start",
            //     "events": [
            //         EmberFlow.SpawnEnemyUnits({
            //             "monsterKeys": ["leshy-green"],
            //         }),
            //     ]
            // },
            {
                "trigger": "manual script",
                "isWinCondition": true,
                "encounterKey": 1,
                "events": [
                    HandleSlowDeath(),
                    EmberFlow.MoveEncounter({"nextEncounterKey": 2})
                ]
            },
            {
                "trigger": "manual script",
                "isWinCondition": true,
                "encounterKey": 2,
                "events": [
                    HandleSlowDeath(),
                    EmberFlow.MoveEncounter({"nextEncounterKey": 3})
                ]
            },
            {
                "trigger": "manual script",
                "isWinCondition": true,
                "encounterKey": 3,
                "events": [
                    HandleSlowDeath(),
                    ...EmberFlow.Ending(),
                ]
            },
            {

                "condition": function(stage) {
                    return PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": stage.player.affiliation})
                },
                "events": [
                    PlotSteps.ChapterFailure(),
                    PlotSteps.BlackoutDialogue("It is the nature of dreams to end"),
                    PlotSteps.BlackoutDialogue("But only until the morrow when we dream once again"),
                    {"func": () => App.game.chapter.restart()},
                ]
            },
        ]
    },
}
